<template>
  <div>
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: 'GroupInviteLink',
  data: function () {
    return {
      
    }
  }
}
</script>

<style scoped lang="scss">
</style>
  